
define("rv!templates/partials/chatWithUs",[],function(){return { v:3,
  t:[ { t:7,
      e:"br" },
    { t:7,
      e:"br" },
    { t:7,
      e:"span",
      a:{ "class":"sideNote" },
      f:[ "More Questions? ",
        { t:7,
          e:"a",
          a:{ href:"#",
            "class":"openOlark" },
          v:{ click:"openChat" },
          f:[ "Chat with us!" ] } ] } ] };});
